// extracted by mini-css-extract-plugin
export default {"cardsContainer":"DashboardPage_cardsContainer__i-DHJ","cards":"DashboardPage_cards__qB8k6","noCardsHead":"DashboardPage_noCardsHead__WqLas","noCards":"DashboardPage_noCards__BDJY0"};